import type { Timestamp } from 'firebase/firestore'
import { PlannedDeliveryStatus } from '~/models/PlannedDelivery/PlannedDelivery'
import type { PuppetProcessingAction } from '~/utils/dateHelpers/getPuppetProcessingDate'

export interface PlannedDelivery {
  id: string
  expectedDeliveryDate: Timestamp
  isLocked: boolean
  status: PlannedDeliveryStatus
  userId: string
  user: User
  autoClickerProcessingDetails?: AutoClickerProcessingDetails
  updated: Timestamp
  isRushDelivery: boolean
  earliestAuthorisationDate?: Timestamp | null
  ticketUrl?: string
}

export interface AutoClickerProcessingDetails {
  date?: Date
  status?: PuppetProcessingAction
}
export interface PlannedDeliveryDetail extends PlannedDelivery {
  deliveryItems: DeliveryItem[]
}

/**
 * The MAIS UI grouping ("which tab does a delivery end up in") — NOT the real
 * data status. Each tab maps to a real PlannedDeliveryStatus via TAB_TO_STATUS.
 */
export type PlannedDeliveryTab
  = | 'toCheck'
    | 'checkAgain'
    | 'checked'
    | 'readyToPrescribe'
    | 'prescribed'
    | 'shipped'
    | 'failed'

export const TAB_TO_STATUS: Record<PlannedDeliveryTab, PlannedDeliveryStatus>
  = {
    toCheck: PlannedDeliveryStatus.Planned,
    checkAgain: PlannedDeliveryStatus.CheckAgain,
    checked: PlannedDeliveryStatus.Approved,
    readyToPrescribe: PlannedDeliveryStatus.Processing,
    prescribed: PlannedDeliveryStatus.ParcelCreated,
    shipped: PlannedDeliveryStatus.Shipped,
    failed: PlannedDeliveryStatus.Failed,
  }

export const STATUS_TO_TAB: Record<PlannedDeliveryStatus, PlannedDeliveryTab>
  = {
    [PlannedDeliveryStatus.Planned]: 'toCheck',
    [PlannedDeliveryStatus.CheckAgain]: 'checkAgain',
    [PlannedDeliveryStatus.Approved]: 'checked',
    [PlannedDeliveryStatus.Processing]: 'readyToPrescribe',
    [PlannedDeliveryStatus.ParcelCreated]: 'prescribed',
    [PlannedDeliveryStatus.Shipped]: 'shipped',
    [PlannedDeliveryStatus.Failed]: 'failed',
  }

export type PlannedDeliveryCount = Partial<Record<PlannedDeliveryTab, number>>

export interface PlannedDeliveryFilters {
  status: PlannedDeliveryStatus
  start?: Date
  end?: Date
}
